export const CODE_RESEND_DELAY_IN_SECONDS = 60;

export const PHONE_VERIFICATION_CODE_SENT_LS_KEY = "phoneVerificationCodeSent";
export const PHONE_VERIFICATION_TIMER_START_LS_KEY = "phoneVerificationTimerStart";
export const CODE_RESEND_DELAY_IN_SECONDS = 60;

export const PHONE_VERIFICATION_CODE_SENT_LS_KEY = "phoneVerificationCodeSent";
export const PHONE_VERIFICATION_TIMER_START_LS_KEY = "phoneVerificationTimerStart";
